<h1 mat-dialog-title>{{ 'executionEdit.event.title' | translate }}</h1>
<form>

  <div mat-dialog-content class="thermal-theme" style="min-height: 10vh;">

    <div class="custom-slider defrost-slider thermal-range-slider">
      <div #rangeChart style="width: 100%; height: 100%;"></div>
      <p *ngIf="chartUnavailable" class="mat-error" role="alert">{{ 'executionEdit.events.form.warning.chartUnavailable' | translate }}</p>
      <ngx-slider 
        *ngIf="valueMin && valueMax"
        [(value)]="valueMin"
        [(highValue)]="valueMax"
        [options]="options"
        (userChangeStart)="onUserChangeStart($event)"
        (userChangeEnd)="onUserChange($event)">
      </ngx-slider>
      
    </div>

    <div fxLayout="row">

      <div fxFlex>
        <mat-form-field>
          <mat-label>{{ 'defrost.startDate.label' | translate }}</mat-label>
          <input matInput [(ngModel)]="startDateStr" name="startDate" (change)="onDateFieldChange()">
        </mat-form-field>
      </div>
      <div fxFlex>
        <mat-form-field>
          <mat-label>{{ 'defrost.endDate.label' | translate }}</mat-label>
          <input matInput [(ngModel)]="endDateStr" name="endDate" (change)="onDateFieldChange()">
        </mat-form-field>
      </div>
      <div fxFlex>
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'defrost.type.label' | translate }}</mat-label>
          <mat-select name="type" [(ngModel)]="data.defrost.idType">
            @for (item of types; track item) {
              <mat-option [value]="item.id">
                {{ 'defrostType.' + item.translation | translate }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

    </div>
  </div>

  <div mat-dialog-actions class="thermal-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()">{{ 'button.save' | translate }}</button>
    <div fxFlex="5px"></div>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>
